import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import {
    Select,
    Checkbox,
    ListItemText,
    OutlinedInput,
    FormControl,
    InputLabel,
    Button,
    Typography,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import { styled } from '@mui/system';
import instance from '../../utils/Api';
import Topbar from '../layouts/Topbar';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import Divider from '@mui/material/Divider';

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const Textarea = styled(BaseTextareaAutosize)(
    ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }

    /* firefox */
    &:focus-visible {
      outline: 0;
    }
  `,
);


const Campaign = () => {
    const [classId, setClassId] = useState([]);
    const [classes, setClasses] = useState();
    const [section, setSection] = useState();
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedtea, setSelectedtea] = useState([]);
    const [students, setStudents] = useState();
    const [teachers, setTeachers] = useState();
    const [studentMessage, setStudentMessage] = useState();
    const [teacherMessage, setTeacherMessage] = useState();
    const [selectedSectionIds, setSelectedSectionIds] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectedTeachers, setSelectedTeachers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);


    console.log(selectedtea);
    console.log(selectedTeachers);
    console.log(teachers);

    const handleChange = (event) => {
        const value = event.target.value;
        if (value.includes("all")) {
            const allIds = selectedStudents.map((item) => item._id);
            setSelectedItems(selectedItems.length === selectedStudents.length ? [] : allIds);
        } else {
            setSelectedItems(value);
        }
    };
    const handleteachersChange = (event) => {
        const value = event.target.value;
        if (value.includes("all")) {
            const allIds = selectedTeachers.map((item) => item._id);
            setSelectedtea(selectedtea.length === selectedTeachers.length ? [] : allIds);
        } else {
            setSelectedtea(value);
        }
    };

    const handleSectionChange = (sectionId) => {
        setSelectedSectionIds((prev) =>
            prev.includes(sectionId)
                ? prev.filter((id) => id !== sectionId) // Remove if already selected
                : [...prev, sectionId] // Add if not selected
        );
    };

    useEffect(() => {
        if (selectedSectionIds.length > 0) {
            const filteredStudents = students?.filter((student) => {
                return selectedSectionIds?.includes(student.section);
            });
            setSelectedStudents(filteredStudents); // Use the state setter function here
        }
    }, [selectedSectionIds, students]); // Add `students` as a dependency if it changes


    // const handlTeachersChange = (event) => {
    //     const value = event.target.value;

    //     // Handle "Select All" functionality
    //     if (value.includes("all")) {
    //         const allIds = teachers.map((item) => item._id); // Extract all student IDs
    //         setTeachersId(teachersId.length === teachers.length ? [] : allIds);
    //     } else {
    //         setTeachersId(value);
    //     }
    // };

    // const handleclassChange = (event) => {
    //     const value = event.target.value;

    //     // Handle "Select All" functionality
    //     if (value.includes("all")) {
    //         const allIds = classes.map((item) => item._id); // Extract all student IDs
    //         setClassId(classId.length === classes.length ? [] : allIds);
    //     } else {
    //         setClassId(value);
    //     }
    // };

    const isAllSelected = selectedItems?.length === selectedStudents?.length;
    const isAllTeaSelected = selectedtea?.length === selectedTeachers?.length;

    const getClass = async (e) => {
        try {
            const response = await instance.get("/api/v1/newrouts/getClasses");
            setClasses(response.data.data);
        } catch (error) {
            console.log("Error", error);
            if (error.response && error.response.data) {
                toast.error(JSON.stringify(error.response.data)); // Display error message
            } else {
                toast.error('An error occurred'); // Display generic error message
            }
        }
    }
    const getSections = async (e) => {
        try {
            const response = await instance.get("/api/v1/newrouts/getSection");
            setSection(response.data.data);
        } catch (error) {
            console.log("Error", error);
            if (error.response && error.response.data) {
                toast.error(JSON.stringify(error.response.data)); // Display error message
            } else {
                toast.error('An error occurred'); // Display generic error message
            }
        }
    }
    useEffect(() => {
        getClass();
        getSections();
    }, []);
    const getStudents = async () => {
        try {
            const response = await instance.get("/api/v1/newrouts/getStudents");
            setStudents(response.data.data);
        } catch (error) {
            if (error.response && error.response.data) {
                alert(JSON.stringify(error.response.data)); // Display error message
            } else {
                alert('An error occurred'); // Display generic error message
            }
        }
    }
    const getTeachers = async () => {
        try {
            const response = await instance.get("/api/v1/newrouts/getTeacher");
            setSelectedTeachers(response.data.data);
            setTeachers(response.data.data);
        } catch (error) {
            if (error.response && error.response.data) {
                alert(JSON.stringify(error.response.data)); // Display error message
            } else {
                alert('An error occurred'); // Display generic error message
            }
        }
    }
    useEffect(() => {
        getStudents();
        getTeachers();
    }, [classId]);

    const sendData = async () => {
        if (!studentMessage && checked === false) {
            return toast.error("Please Select Text Message");
        }
        setLoading(true);
        try {
            const studentsData = students?.filter(item => selectedItems?.includes(item._id));
            const TeachersData = teachers?.filter(item => selectedtea?.includes(item._id));
            console.log(TeachersData);

            const response = await instance.post("/api/v1/campaign/sendMessage", {
                students: studentsData,
                teachers: TeachersData,
                studentMessage,
                teacherMessage,
                checked
            })
            if (response.data.success === true) {
                toast.success(response.data.message);
                setSelectedStudents([]);
                setSelectedSectionIds([]);
                setSelectedTeachers([]);
                setStudentMessage('');
                setChecked(false);
            }
            else {
                toast.error(response.data.message);
                setChecked(false);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Topbar />
            <div className="campaign-container">
                <Typography variant='h4' className="campaign-title">Campaign</Typography>
                <div className="campaign-section">
                    <Typography variant='h5' className="campaign-title">Student Campaign</Typography>
                    <Grid container spacing={2} height={'200px'} sx={{ overflowY: 'scroll' }}>

                        {classes &&
                            classes.map((data) => (
                                <React.Fragment key={data._id}>
                                    {/* Class Name */}
                                    <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
                                        <FormGroup>
                                            <FormControlLabel
                                                control={<Checkbox defaultChecked disabled />}
                                                label={data?.name}
                                            />
                                        </FormGroup>
                                    </Grid>

                                    {/* Sections */}
                                    <Grid size={{ xs: 2, sm: 4, md: 4, lg: 8 }}>
                                        {data?.sections?.map((sectionData) => (
                                            <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }} key={sectionData?._id}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={selectedSectionIds.includes(sectionData?._id)}
                                                                onChange={() => handleSectionChange(sectionData?._id)}
                                                            />
                                                        }
                                                        label={sectionData?.name}
                                                    />
                                                </FormGroup>
                                            </Grid>
                                        ))}
                                    </Grid>


                                </React.Fragment>
                            ))}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
                            <FormControl fullWidth>
                                <InputLabel id="students-select-label">Select Students</InputLabel>
                                <Select
                                    labelId="students-select-label"
                                    id="students-select"
                                    multiple
                                    value={selectedItems}
                                    onChange={handleChange}
                                    input={<OutlinedInput label="Select Students" />}
                                    renderValue={(selected) =>
                                        selected
                                            .map((id) => selectedStudents?.find((item) => item._id === id)?.name)
                                            .join(", ")
                                    }
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 224,
                                                width: 250
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="all">
                                        <Checkbox checked={isAllSelected} />
                                        <ListItemText primary="Select All" />
                                    </MenuItem>

                                    {selectedStudents?.map((item) => (
                                        <MenuItem key={item._id} value={item._id}>
                                            <Checkbox checked={selectedItems.includes(item._id)} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth sx={{ marginTop: '10px' }}>
                                <InputLabel id="students-select-label">Select Teachers</InputLabel>
                                <Select
                                    labelId="students-select-label"
                                    id="students-select"
                                    multiple
                                    value={selectedtea}
                                    onChange={handleteachersChange}
                                    input={<OutlinedInput label="Select Teachers" />}
                                    renderValue={(selected) =>
                                        selected
                                            .map((id) => selectedTeachers?.find((item) => item._id === id)?.name)
                                            .join(", ")
                                    }
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 224,
                                                width: 250
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="all">
                                        <Checkbox checked={isAllTeaSelected} />
                                        <ListItemText primary="Select All" />
                                    </MenuItem>

                                    {selectedTeachers?.map((item) => (
                                        <MenuItem key={item._id} value={item._id}>
                                            <Checkbox checked={selectedtea.includes(item._id)} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
                            <Textarea
                                aria-label="minimum height"
                                disabled={checked}
                                sx={{ width: '100%' }}
                                minRows={3}
                                value={studentMessage}
                                onChange={(e) => setStudentMessage(e.target.value)}
                                onKeyDown={(e) => {
                                    // 1️⃣ Block ENTER (new line)
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        return;
                                    }

                                    // 2️⃣ Block four consecutive spaces
                                    if (e.key === " ") {
                                        const current = studentMessage;
                                        const last3 = current?.slice(-3);

                                        // If last three characters are spaces, block the 4th
                                        if (last3 === "   ") {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                placeholder="Message"
                            />
                            {/* <Divider>OR</Divider>
                            <FormControlLabel
                                control={<Checkbox onChange={(e) => setChecked(e.target.checked)} />}
                                label="Want to Send Annual Message Template"
                            /> */}
                        </Grid>
                        <Grid size={{ xs: 2, sm: 4, md: 4, lg: 4 }}>
                            <Button variant="contained" color="primary" onClick={sendData}>Send Message</Button>
                        </Grid>
                    </Grid>
                </div>
            </div >
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}

export default Campaign
